import { render, staticRenderFns } from "./AboutBalkam.vue?vue&type=template&id=92e755ba&scoped=true&"
import script from "./AboutBalkam.vue?vue&type=script&lang=js&"
export * from "./AboutBalkam.vue?vue&type=script&lang=js&"
import style0 from "./AboutBalkam.vue?vue&type=style&index=0&id=92e755ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e755ba",
  null
  
)

export default component.exports